import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { fr } from './fr';
import { fr_ca } from './fr-ca';
import { de } from './de';
import { es } from './es';
import { ja } from './ja';
import { it } from './it';

export const defaultNS = 'common';
export const resources = { en, fr, 'fr-CA': fr_ca, de, es, ja, it } as const;

export const i18n = i18next.createInstance().use(initReactI18next);

void i18n.init({
  lng: 'en', // This will be overridden by useUserLocale
  defaultNS,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

// Keep <html lang> in step with the language actually rendered. The shell
// owns the document and wraps every micro-frontend, so this is the one place
// the attribute is written. `resolvedLanguage` is the language i18next found
// resources for, so a failed or unsupported switch leaves `lang` on the
// fallback instead of labelling English text with another language.
i18n.on('languageChanged', () => {
  document.documentElement.lang = i18n.resolvedLanguage ?? 'en';
});
